import { ExecutiveFilters, PeriodFilter } from '../../../../hooks/useExecutiveData';

interface Props {
  filters: ExecutiveFilters;
  plans: { id: string; name: string }[];
  onChange: (f: ExecutiveFilters) => void;
}

const PERIOD_OPTIONS: { value: PeriodFilter; label: string }[] = [
  { value: '7d',   label: 'Últimos 7 dias'  },
  { value: '30d',  label: 'Últimos 30 dias' },
  { value: '90d',  label: 'Últimos 90 dias' },
  { value: '365d', label: 'Este ano'        },
  { value: 'all',  label: 'Todo o período'  },
];

const STATUS_OPTIONS = [
  { value: 'all',      label: 'Todos os usuários' },
  { value: 'active',   label: 'Apenas ativos'     },
  { value: 'inactive', label: 'Apenas inativos'   },
];

export const ExecutiveFiltersBar = ({ filters, plans, onChange }: Props) => {
  const set = (partial: Partial<ExecutiveFilters>) => onChange({ ...filters, ...partial });

  return (
    <div className="flex flex-wrap items-center gap-3 mb-6">
      {/* LGPD badge */}
      <div className="flex items-center gap-1.5 px-3 py-1.5 bg-emerald-500/10 border border-emerald-500/30 rounded-xl text-emerald-400 text-[12px] font-600 mr-auto">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-shield-check-line text-[14px]" />
        </div>
        LGPD — apenas dados agregados e anônimos
      </div>

      {/* Period */}
      <select
        value={filters.period}
        onChange={(e) => set({ period: e.target.value as PeriodFilter })}
        className="bg-white/5 border border-white/10 text-white text-[13px] rounded-xl px-3 py-2 cursor-pointer outline-none focus:border-violet-500/50 transition-colors"
      >
        {PERIOD_OPTIONS.map((o) => (
          <option key={o.value} value={o.value} className="bg-[#1a1a2e]">{o.label}</option>
        ))}
      </select>

      {/* Plan */}
      <select
        value={filters.planId || ''}
        onChange={(e) => set({ planId: e.target.value || null })}
        className="bg-white/5 border border-white/10 text-white text-[13px] rounded-xl px-3 py-2 cursor-pointer outline-none focus:border-violet-500/50 transition-colors"
      >
        <option value="" className="bg-[#1a1a2e]">Todos os planos</option>
        {plans.map((p) => (
          <option key={p.id} value={p.id} className="bg-[#1a1a2e]">{p.name}</option>
        ))}
      </select>

      {/* User status */}
      <select
        value={filters.userStatus}
        onChange={(e) => set({ userStatus: e.target.value as any })}
        className="bg-white/5 border border-white/10 text-white text-[13px] rounded-xl px-3 py-2 cursor-pointer outline-none focus:border-violet-500/50 transition-colors"
      >
        {STATUS_OPTIONS.map((o) => (
          <option key={o.value} value={o.value} className="bg-[#1a1a2e]">{o.label}</option>
        ))}
      </select>
    </div>
  );
};
